import { render, staticRenderFns } from "./OfferTile.vue?vue&type=template&id=5ae943f4&scoped=true&"
import script from "./OfferTile.vue?vue&type=script&lang=ts&"
export * from "./OfferTile.vue?vue&type=script&lang=ts&"
import style0 from "./OfferTile.vue?vue&type=style&index=0&id=5ae943f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae943f4",
  null
  
)

export default component.exports